import { Card } from "antd";
import { useParams } from "@tanstack/react-router";
import { useState } from "react";
import StudioLiveChat from "../component/Studio/StudioLiveChat";
import LiveStudio from "../component/Studio/liveStudio";
// import YTVideo from "../component/Studio/YTVideo";
// import Rendered from "../component/Studio/Rendered";
import YoutubeLiveStudio from "../component/Studio/youtubeLiveStudio";
// import StudioVideoDetails from "./studioVideoDetails";

import useStudio from "../hooks/useStudio";
const AUTH_TOKEN = localStorage.getItem("AUTH_TOKEN");
export default function Studio() {
  const params = useParams({ from: "" });
  const { video, course, setVideo, iframeKey } = useStudio(params);
  const [player, setPlayer] = useState<"old" | "new">("old");


  return (
    <Card
      styles={{
        body: {
          padding: 0,
        },
      }}
      loading={!video}
      className="bg-muted"
    >
      <div
        className="
        grid items-start 
        grid-cols-1
        xl:grid-cols-[minmax(0,1fr)_520px]
      "
      >
        <div className="min-w-0 h-[calc(100vh-30px)]">
          {["yt", "youtube"].includes(video?.videoType?.toLowerCase?.()) ? (
            <YoutubeLiveStudio
              player={player}
              setPlayer={setPlayer}
              course={course!}
              frameKey={iframeKey}
              video={video}
              onDone={(video) => setVideo(video)}
            />
          ) : (
            <LiveStudio
              player={player}
              setPlayer={setPlayer}
              course={course!}
              frameKey={iframeKey}
              video={video}
              onDone={(video) => setVideo(video)}
            />
          )}
        </div>
        <div className="sticky  h-[calc(100vh-30px)]">
          <div className="relative overflow-hidden rounded-2xl">
            <div className="overflow-hidden rounded-2xl">
              {AUTH_TOKEN && (
                <StudioLiveChat
                  videoId={video?.vid?.toString()}
                  token={AUTH_TOKEN}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </Card>
  );
}
